<template>
  <div :title="getPageTitle" class="pageTitle" >
    <p class="header" v-text="title"></p>
    <p class="h-p">
      <span v-if="headerTitle" v-text="headerTitle"></span>
      <span v-if="text" class="h-span" v-text="text" />
    </p>
  </div>
</template>

<script>
export default {
  name: "pageTitle",
  props: {
    pageTitle: "",
    headerTitle: "",
    text: undefined
  },
  data() {
    return {
      title: undefined
    };
  },
  computed: {
    getPageTitle() {
      const { pageTitle } = this;
      this.title = pageTitle || this.$route?.meta?.title || ''
      return this.pageTitle;
    }
  }
};
</script>

<style scoped>
.pageTitle {
  background-color: #fff;
  padding: 24px;
}
.header {
  height: 50px;
  font-size: 24px;
  font-weight: 500;
  border-bottom: 1px solid #eee;
  margin-left: 5px;
}

.h-p {
  font-size: 12px;
  /*margin:15px 0 !important;*/

}

.h-p span {
  display: inline-block;
  line-height: 24px;
  margin: 10px 5px 10px 0 !important;
}

.h-span {

  color: #A6A6A6
}
</style>
